export default "__VITE_ASSET__D3robrHH__"